export default {
  category_id: null,
  description: null,
  quantity: null,
  articles: [],
  unit: 'kg',
}
